import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { getSettings } from './api';
import Home from './pages/Home';
import Admin from './pages/Admin';
import './index.css';

export default function App() {
  const [settings, setSettings] = useState({ site_title: 'El Popular', logo_url: '', logo_circular_url: '', logo_size: 52 });

  const loadSettings = () => getSettings().then(s => setSettings({
    site_title: s.site_title || 'El Popular',
    logo_url: s.logo_url || '',
    logo_circular_url: s.logo_circular_url || '',
    logo_size: parseInt(s.logo_size) || 52,
  })).catch(() => {});

  useEffect(() => { loadSettings(); }, []);

  const logoStyle = {
    height: `${settings.logo_size}px`,
    width: 'auto',
    maxWidth: '800px',
    objectFit: 'contain',
    borderRadius: '0',
    border: 'none',
  };

  return (
    <BrowserRouter basename={window.__BASE_PATH__ || '/'}>
      <nav className="navbar">
        <Link to="/" className="navbar-brand">
          {settings.logo_url
            ? <img src={settings.logo_url} alt="logo" style={logoStyle} />
            : <span style={{ color: 'var(--mustard)', fontStyle: 'italic', letterSpacing: 2 }}>{settings.site_title}</span>
          }
        </Link>
      </nav>
      <Routes>
        <Route path="/" element={<Home settings={settings} />} />
        <Route path="/369admin" element={<Admin onSettingsChange={loadSettings} />} />
      </Routes>
    </BrowserRouter>
  );
}
